import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SharedModule } from '../shared/shared.module';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppMenuBuilderService } from './services/app-menu-builder.service';
import { CookiesConsentComponent } from './cookies-consent/cookies-consent.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { UnauthenticatedLayoutComponent } from './unauthenticated-layout/unauthenticated-layout.component';
import { HelpSidePanelComponent } from './help-side-panel/help-side-panel.component';
import { HelpArticleDirective } from '@app/shared/directives/help-article.directive';
import { BlankLayoutComponent } from './blank-layout/blank-layout.component';

@NgModule({
    declarations: [
        BlankLayoutComponent,
        HeaderComponent,
        FooterComponent,
        HeaderMenuComponent,
        CookiesConsentComponent,
        MainLayoutComponent,
        UnauthenticatedLayoutComponent,
        HelpSidePanelComponent,
    ],
    exports: [BlankLayoutComponent, HeaderComponent, FooterComponent, CookiesConsentComponent],
    imports: [RouterModule, CommonModule, SharedModule, HelpArticleDirective],
    providers: [AppMenuBuilderService],
})
export class LayoutModule {}
